import {
  BusinessHoursInfoResponse,
  parse as parseBusinessHoursInfoResponse,
} from 'src/modules/apis/business-hours-info/response'
import {
  Pharmacy,
  PharmacyForFreeDelivery,
} from 'src/modules/entities/pharmacy/entity'
import { PHARMACY_API_URL } from 'src/modules/server/const'
import { requestGet } from 'src/modules/server/request'

type FreeDeliveryPharmacyResponse = Pick<
  Pharmacy,
  | 'uid'
  | 'name'
  | 'postal'
  | 'prefecture'
  | 'city'
  | 'district'
  | 'building'
  | 'fax'
> & {
  business_hour_info: BusinessHoursInfoResponse | null
  free_delivery_available: boolean
}

export type Params = {
  clinic_uid: string
}
export const fetch = async (params: Params) => {
  const resp = await requestGet<{
    nearest_free_delivery_pharmacy: FreeDeliveryPharmacyResponse
    pharmacies: FreeDeliveryPharmacyResponse[]
  }>({
    url: `${PHARMACY_API_URL}/patients/pharmacies/free_deliveries/search.json`,
    params: {
      clinic_uid: params.clinic_uid,
    },
  })

  return {
    nearestFreeDeliveryPharmacy:
      resp.data.nearest_free_delivery_pharmacy &&
      parse(resp.data.nearest_free_delivery_pharmacy),
    pharmacies: resp.data.pharmacies
      ? resp.data.pharmacies.map(p => parse(p))
      : [],
  }
}

const parse = (
  resp: FreeDeliveryPharmacyResponse,
): PharmacyForFreeDelivery => ({
  uid: resp.uid,
  name: resp.name,
  postal: resp.postal,
  prefecture: resp.prefecture,
  city: resp.city,
  district: resp.district,
  building: resp.building,
  fax: resp.fax,
  businessHourInfo: resp.business_hour_info
    ? parseBusinessHoursInfoResponse(resp.business_hour_info)
    : null,
  freeDeliveryAvailable: resp.free_delivery_available,
})
